import styled from 'styled-components';

import { MultiSelectChips } from 'components/shared/form/InfiniteScrollDropdown';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

type Facility = { id: string; name: string };

type FacilityPickerProps = {
  facilities: Facility[];
  selected: Set<string>;
  onChange: (next: Set<string>) => void;
  emptyText: string;
};

export default function FacilityPicker({ facilities, selected, onChange, emptyText }: FacilityPickerProps) {
  if (facilities.length === 0) return <Muted>{emptyText}</Muted>;

  return (
    <div>
      <MultiSelectChips<Facility>
        title='Select Facilities'
        placeholder='Select Facilities'
        options={facilities}
        values={facilities.filter((facility) => selected.has(facility.id))}
        getOptionValue={(facility) => facility.id}
        getOptionLabel={(facility) => facility.name}
        onChange={(picked) => onChange(new Set(picked.map(({ id }) => id)))}
      />
      <SelectAll type='button' onClick={() => onChange(new Set(facilities.map(({ id }) => id)))}>
        Select all facilities
      </SelectAll>
    </div>
  );
}

const SelectAll = styled.button`
  margin-top: 8px;
  padding: 0;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 12px;
  color: ${colors.blue100};
  text-decoration: underline;
  cursor: pointer;
`;

const Muted = styled(BodySmall)`
  color: ${colors.black50};
`;
